export const ProductFormSkeleton = () => {
  return (
    <div className="w-full mt-5 flex flex-col justify-between h-[70vh]">
      <div className="flex flex-col gap-6 md:gap-8">
        {/* Product Name Input skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded-md w-24 animate-pulse"></div>
          <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>

        {/* Product Description Input skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded-md w-36 animate-pulse"></div>
          <div className="w-full h-24 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>

        {/* Variants Section skeleton */}
        <div>
          <div className="h-6 bg-gray-200 rounded-md w-20 mb-3 animate-pulse"></div>

          {/* Variants form skeleton */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
            {/* Quantity Input skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded-md w-16 animate-pulse"></div>
              <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>

            {/* Product Price Input skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded-md w-24 animate-pulse"></div>
              <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>

            {/* Discount Percentage Input skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded-md w-20 animate-pulse"></div>
              <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>
          </div>

          {/* Add Variant Button skeleton */}
          <div className="flex justify-end my-4">
            <div className="w-full sm:w-32 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
